import { render, staticRenderFns } from "./VehicleBanner.vue?vue&type=template&id=37ed4206&scoped=true"
import script from "./VehicleBanner.vue?vue&type=script&lang=ts"
export * from "./VehicleBanner.vue?vue&type=script&lang=ts"
import style0 from "./VehicleBanner.vue?vue&type=style&index=0&id=37ed4206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed4206",
  null
  
)

export default component.exports